export const buildAuroraCadUrl = (
  auroraProjectId: string | null | undefined,
  designId: string | null | undefined,
): string | null => {
  const normalizedProjectId = auroraProjectId?.trim()
  const normalizedDesignId = designId?.trim()

  if (!normalizedProjectId || !normalizedDesignId) {
    return null
  }

  return `https://v2.aurorasolar.com/projects/${encodeURIComponent(normalizedProjectId)}/designs/${encodeURIComponent(normalizedDesignId)}/cad`
}
